module.exports = "<header class=\"header\">\r\n  <lfwms-menu></lfwms-menu>\r\n  <lfwms-profile></lfwms-profile>\r\n</header>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/header/header.component.html
// module id = ../../../../../src/app/layout/home/header/header.component.html
// module chunks = main